module.exports = __webpack_public_path__ + "static/media/business-philosophy-ad1.13aa636a.jpg";